import ContentText from './contentText'

export default ContentText